<template>
    <div class="editor_scene-options">
        <imageElementOptions
            v-if="getActiveElement.type === 'IMAGE_ELEMENT'  || (getActiveElement.type === 'PHOTO_CELL_ELEMENT' && !getActiveElement.maskImg.isFromSvg)"
        />
        <shapeElementOptions
            v-if="getActiveElement.type === 'SHAPE_ELEMENT' || (getActiveElement.type === 'PHOTO_CELL_ELEMENT' && getActiveElement.maskImg.isFromSvg)"
        />
        <textElementOptions
            v-if="getActiveElement.type === 'TEXT_ELEMENT'"
        />
        <qrElementOptions
            v-if="getActiveElement.type === 'QR_CODE_ELEMENT'"
        />
        <div class="editor_scene-options-const">
            <lockElement v-if="showLockIcon" />
            <deleteElement v-if="Object.keys(this.getActiveElement).length > 0" />
            <positionElement v-if="Object.keys(this.getActiveElement).length > 0" />
            <setElementPosition v-if="Object.keys(this.getActiveElement).length > 0" />
            <seeAllElements />
        </div>
        <publishProjectBtn v-if="getSessionDetails.mode === 'merchant'" />
        <saveProjectBtn v-if="showSaveBtn" />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import lockElement from './ElementsOptions/lockElement.vue';
    import deleteElement from './ElementsOptions/deleteElement.vue';
    import positionElement from './ElementsOptions/positionElement.vue';
    import seeAllElements from './ElementsOptions/seeAllElements.vue';
    import setElementPosition from './ElementsOptions/setElementPosition.vue';
    import imageElementOptions from './ElementsOptions/imageElementOptions.vue';
    import shapeElementOptions from './ElementsOptions/shapeElementOptions.vue';
    import textElementOptions from './ElementsOptions/textElementOptions.vue';
    import qrElementOptions from './ElementsOptions/qrElementOptions.vue';
    import saveProjectBtn from '../Scene/ElementsOptions/saveProject.vue';
    import publishProjectBtn from '../Scene/ElementsOptions/publishProject.vue';

    export default {
        computed: {
            showLockIcon() {
                if (this.getSessionDetails.mode === 'merchant') {
                    if (Object.keys(this.getActiveElement).length > 0) {
                        return true;
                    } return false;
                }

                return false;
            },
            ...mapGetters([
                'getSessionDetails',
                'getActiveElement'
            ]),
            showSaveBtn() {
                if (this.getSessionDetails.mode === 'user') {
                    if (this.getSessionDetails.productGatewayEnabled === true ) {
                        return false;
                    } return true;
                } 
                return true;
            }
        },
        components: {
            lockElement,
            deleteElement,
            positionElement,
            seeAllElements,
            setElementPosition,
            imageElementOptions,
            shapeElementOptions,
            textElementOptions,
            qrElementOptions,
            saveProjectBtn,
            publishProjectBtn
        }
    }
</script>

<style lang="scss">
    @import '@/styles/setup/_variables.scss';

    .editor_scene-options {
        background-color: #f5f5f5;
        padding: 5px;
        display: flex;
        align-items: flex-start;
        box-sizing: border-box;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        z-index: 100;
        border-bottom: 1px solid #D4D4D4;

        button {
            svg:hover {
                fill: var(--primary-color);
            }
        }
    }
    .editor_scene-options-const {
        margin: 0 0 0 auto;
        display: flex;
    }
</style>